<script lang="ts">
	import IconAction from './IconAction.svelte';
	import { t } from 'svelte-i18n';

	export let iconName = 'grade';
	export let items = [];
	export let rating: number;
	export let color;
	export let currentRating = rating;

	export let hasAlreadyVoted = false;
</script>

<div
	class="space-x-2 {hasAlreadyVoted ? 'hasAlreadyVoted' : ''}"
	on:mouseleave={() => {
		rating = currentRating;
	}}
>
	{#each items as item}
		<IconAction
			tooltipTitle={hasAlreadyVoted ? $t('operation.hasAlreadyVoted') : item.tooltip}
			tooltipPosition="top"
			{iconName}
			classNames="inline-block {color ? `text-${color}` : ''}"
			handleMouseEnter={() => {
				if (!hasAlreadyVoted) {
					rating = item.value;
				}
			}}
			active={item.value <= rating}
			on:click={() => {
				if (!hasAlreadyVoted) {
					currentRating = item.value;
				}
			}}
			on:click
			isRating={true}
			size="small"
		/>
	{/each}
</div>

<style lang="postcss">
	div.hasAlreadyVoted :global(svg.outlined:hover) {
		fill: none;
	}
</style>
